import Utils from '../utils/utils';
import LocalData from '../utils/local-data';

// User ID
let clientId = LocalData.get('clientId');

if (!clientId) {
  clientId = Utils.guid();
  LocalData.set('clientId', clientId);
}

const cid = clientId;

export default cid;
